import React, { createContext, FC, useState } from 'react';

interface IAdminUserContext {
  selectedAdminTab: string;
  setSelectedAdminTab: (val: string) => void;
  selectedUsersTab: number;
  setSelectedUsersTab: React.Dispatch<React.SetStateAction<number>>;
}

export const AdminContext = createContext<IAdminUserContext>({
  selectedAdminTab: '',
  setSelectedAdminTab: () => {},
  selectedUsersTab: 0,
  setSelectedUsersTab: () => {}
});

interface IAdminContextHandlerProps {}

export const AdminContextHandler: FC<IAdminContextHandlerProps> = ({ children }): JSX.Element => {
  const [selectedAdminTab, setSelectedAdminTab] = useState<string>('Manage Tools');
  const [selectedUsersTab, setSelectedUsersTab] = useState<number>(0);

  return (
    <AdminContext.Provider
      value={{ selectedAdminTab, setSelectedAdminTab, selectedUsersTab, setSelectedUsersTab }}
    >
      {children}
    </AdminContext.Provider>
  );
};
